import { RefObject, useEffect, useRef } from "react";

type SupportedElement = HTMLDivElement | HTMLOListElement | HTMLUListElement;
export function useScrollEnd<T extends SupportedElement>(onEnd: () => void, { threshold = 1, once = true } = {}): RefObject<T | null> {
    const ref = useRef<T | null>(null);
    const triggeredRef = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const handleScroll = () => {
            const isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - threshold;

            if (isAtEnd) {
                if (!once || !triggeredRef.current) {
                    triggeredRef.current = true;
                    onEnd();
                }
            } else {
                triggeredRef.current = false;
            }
        };

        el.addEventListener("scroll", handleScroll);
        return () => el.removeEventListener("scroll", handleScroll);
    }, [onEnd, threshold, once]);

    return ref;
}
